import {
  Card,
  CardHeader,
  IconButton,
  Skeleton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { Suspect } from './Suspect';
import { useNicheSuspect } from './useNicheSuspect';
import { FlagAvatar } from './FlagAvatar';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { DetailsPanel } from '@/components/controls';

export function HighPrioritySuspect({
  personId,
  occurrenceId,
  onOptionClick,
  onShowMapClick,
  onDeleteClick,
}) {
  const {
    query: { data: suspect, isFetching },
  } = useNicheSuspect(personId, occurrenceId);

  if (isFetching) {
    return <Skeleton variant="rounded" sx={{ minWidth: 240 }} height={240} />;
  }

  return suspect ? (
    <Suspect
      suspect={suspect}
      onOptionClick={onOptionClick}
      onShowMapClick={onShowMapClick}
    />
  ) : (
    <Card variant="outlined" sx={{ minWidth: 240 }}>
      <CardHeader
        avatar={<FlagAvatar />}
        action={
          <Tooltip title="Delete">
            <IconButton size="small" color="error" onClick={onDeleteClick}>
              <DeleteIcon sx={{ fontSize: 'inherit' }} />
            </IconButton>
          </Tooltip>
        }
        title="Not Found"
        sx={{ textTransform: 'capitalize' }}
      />
      <Stack spacing={1} sx={{ p: 1 }}>
        <Typography variant="body2" sx={{ p: 0.5 }}>
          This record cannot be found.
        </Typography>
        <DetailsPanel
          entries={[
            {
              label: 'Person ID',
              value: personId,
            },
            {
              label: 'Occurrence ID',
              value: occurrenceId,
            },
          ]}
        />
      </Stack>
    </Card>
  );
}
